import { AfterContentChecked, AfterViewChecked, AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, HostListener, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';
import { CoxService } from 'src/app/app-business-object-module/cox.service';
import { AppService } from 'src/app/app.service';
import {TranslateService} from '@ngx-translate/core';
import { DhlFormControl } from '../../models/dhl-form-control';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import { APP_Constants } from 'src/app/app.constant';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';
import  {Constant}  from '../../../constants/constants';

@Component({
    selector: 'app-form-field-dropdown-simple-v2',
    templateUrl: './form-field-dropdown-simple-v2.component.html',
    styleUrls: ['./form-field-dropdown-simple-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldDropdownSimpleV2Component implements OnInit, AfterViewInit, AfterViewChecked {

  constructor(private cdr: ChangeDetectorRef,private _eref: ElementRef, private appService: AppService, private coxService :CoxService, private alphaService: AlphaService, private modalService : ModalService,public translate: TranslateService) { }

  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;
  @ViewChild('visibleFormControl',{static: false, read: ElementRef}) visibleFormControl: ElementRef;
  @ViewChild('visibleDropdownList',{static: false, read: ElementRef}) visibleDropdownList: ElementRef;
  @ViewChild('formControl',{static: true, read: ElementRef}) formControl: ElementRef;

  validationType: string = '';
  toggleList: boolean = false;
  disabled: boolean = false;
  fieldControl: any;
  listOptions: any;
  PreferredUom: any;
	showSavedFilter: boolean = true;
  showDeleteFilterButton: boolean = false;
  selfServiceConfig: boolean = false;
  editField: boolean;
  isLoading: boolean;
  templateData: any;
    orderFormSubmitted: any;
  orderForm: any;
  infoMsg: any;

  ngOnInit() {
    if(this.configData.customFormFlag){
      this.selfServiceConfig = false;
    }
    else if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }
    if(this.configData.apiUrl){
      let url = this.configData.apiUrl + localStorage.getItem('userName');
      url += '&customerCode=';
      this.appService.makeHttpGetRequest(url).subscribe((customerRes:any) => {
        if(customerRes.message.statusCode == "SUCCESS"){
          this.listOptions = customerRes.data.customerData;
            }
            })
    }
    else{
      this.listOptions = this.configData.options;
    }
    
    if(this.configData['filterType'] ==='savedSearchFilter'){
      if(this.configData.options.length > 1){
        this.showSavedFilter = true;
      }
      else{
        this.showSavedFilter = false;
      }
    }

    this.fieldControl = this.frmGroup.get(this.configData.name);
    // This should be remove when all featureNames get updated
    let menuPageAccess;
    if(this.configData["menuPageAccess"]){
      menuPageAccess = this.configData["menuPageAccess"];
    } else {
      menuPageAccess = this.configData["access"];
    }
    if (menuPageAccess) {
      this.frmGroup.get(this.configData.name)['hidden'] = !this.checkAccess(menuPageAccess)
    }

    //passing Object
    setTimeout(() => {

      if (this.configData['dynamicVisibility']) {
        if(this.configData['dynamicVisibility'].action == 'hidden'){
          this.frmGroup.get(this.configData.name)['hidden'] = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
        }else
        if(this.configData['dynamicVisibility'].action == 'disabled'){
          this.disabled = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
        }
      }
      let sourceData = this.frmGroup.get(this.configData.name).value;
      let poLineSelectedData = JSON.parse (localStorage.getItem('selectedPoLines'));
      let copyOrderResData = JSON.parse (localStorage.getItem('copyOrderRes'));
      let events = this.configData?.events;
      if (events && events.length > 0) {
        let res = events.find(event => event.actionType)
        if (res && res.actionType === 'ONLOAD_SET_DATA') {
          let result = {};
          let otmKeys;
          if (poLineSelectedData !== null) {
            otmKeys = res.otmKeys;
            otmKeys.forEach(key => {
              result[key] = null;
              poLineSelectedData?.forEach(data => {
                if (data.hasOwnProperty(key)) {
                  result[key] = data[key];
                }
              });
            });
            if (result[otmKeys[0]] === result[otmKeys[1]]) {
              this.frmGroup.get(this.configData.name).setValue(res?.defaultValue.value)
            } else if (sourceData !== undefined && sourceData !== "") {
              this.frmGroup.get(this.configData.name).disable();
            }
          } else if (poLineSelectedData === null && copyOrderResData !== null) {
            this.frmGroup.get(this.configData.name).setValue(copyOrderResData?.rawData?.inco_term_id)
            otmKeys = res.otmKeyscopy || [];
            otmKeys.forEach(key => {
              result[key] = null;
            });
            if (copyOrderResData) {
              Object.keys(copyOrderResData).forEach(dataKey => {
                if (copyOrderResData.hasOwnProperty(dataKey)) {
                  otmKeys.forEach(key => {
                    if (dataKey === key) {
                      result[key] = copyOrderResData[dataKey];
                    }
                  })
                }
              });
            }
            localStorage.removeItem('copyOrderRes')
            if (result[otmKeys[0]] !== result[otmKeys[1]]) {
              this.frmGroup.get(this.configData.name).disable();
            }
          }
        } else if(res?.actionType === 'LOAD_CUSTOMERS_OPTIONS' || res?.actionType === 'LOAD_USER_ROLES_OPTIONS' || res?.actionType === 'CHANGE_USER_ROLES_OPTION' || res?.actionType === 'LOAD_ROLS'){
          this.sendToSource(res, null);
          return;
        }
      }
    }, 0)

    if(this.configData.validation.length)
      this.fieldValueValidation(this.configData.validation);
    // load drop down items dynamically
    //console.log('Check Dynamic value  ', this.configData['dynamicOptions'])
    if (this.configData['dynamicOptions']) {
        this.listOptions = [];
        let userRole = localStorage.getItem('userRole');
        this.configData.options.forEach(option => {
          let roleAccess;
          if(option['roleAccess']){
            roleAccess = option['roleAccess'];
          } else {
            roleAccess = option['personaAccess'];
          }
          if ((roleAccess).includes(userRole))
            this.listOptions.push(option);
        });
        this.configData.options = this.listOptions;
        let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'ONLOAD');
        if (event) {
          this.sendToSource(event, null);
          return
        }
    } else {
        this.listOptions = this.configData.options;
    }
    if (this.configData['storeDataName'] && sessionStorage.getItem(this.configData['storeDataName'])) {
        let formData = JSON.parse(sessionStorage.getItem(this.configData['storeDataName']));
        this.selectedOption(formData, null);
    }
    this.alphaService.checkEditAccess(this.configData, this.frmGroup);
    this.PreferredUom = localStorage.getItem('preferredUOM')
    let url = this.appService.getPreviousUrl();
    if (url === '/ratelookup/result' && sessionStorage.getItem('isRefineSearch') == 'true') {
      if (this.appService.getRawFormValue()) {
        if (this.configData.UoMkey) {
          let rateEnquiryFormData = this.appService.getRawFormValue();
          if (rateEnquiryFormData?.value?.lineItems) {
            let lineItemArr = rateEnquiryFormData.value.lineItems[0];
            const matchKey = Object?.keys(lineItemArr).find(s => s === this.configData.name)
            if (matchKey) {
              setTimeout(() => {
              this.frmGroup.get(this.configData.name).setValue(lineItemArr[matchKey].value);
              }, 1000);
            }
          }
        }
      }
    }

    this.appService.removeWarningMessage$.subscribe(({ name, resetWarningMessage }) => {
      if (this.configData.name === name && resetWarningMessage) {
         this.infoMsg = { 'warning': false, message: '' };
      }
    });
  }

  manageDropdown(e, data) {
    let events = this.configData?.events;
    if (events && events.length > 0) {
        let res = events.find(event => event.actionType)
        if (res?.actionType == 'CHANGE_USER_ROLES_OPTION') {
          this.sendToSource(res, data);
          return
        }
    }
  }

 ngAfterViewChecked(){
    if (this.toggleList && this.visibleDropdownList) {
      // this.visibleDropdownList.nativeElement.style.width = this.visibleFormControl.nativeElement.offsetWidth + 'px';
      this.positionSimpleDropdown();
    }
    if(typeof this.fieldControl?.value === 'string') {
      let itemObj = this.listOptions.find((data)=>{
        if(data['value'].toUpperCase() === this.fieldControl.value.toUpperCase()){
          return data['value'];
        }
      })
      if(itemObj){
        const hasValidationEvent = this.configData?.events?.some(e => e.event === "SELECTED_VALUE");
        if (hasValidationEvent) {
          setTimeout(() => this.selectedOption(itemObj, null, true), 100);
        } else {
          this.selectedOption(itemObj, null, true);
        }
      }
      let frmGroup = this.frmGroup?.get(this.configData?.name);
      if (frmGroup['required'] === false && frmGroup?.errors?.required !== true) {
        this.configData.required = false;
      }
    }
    let frmGroup = this.frmGroup?.get(this.configData?.name);
    if (frmGroup['required'] === false && frmGroup?.errors?.required !== true) {
      this.configData.required = false;
    }
    if (this.configData?.enableDraftSaveWithErrorsFlag) {
        if (this.configData['multiAffectedColumns']) {
          for (let i = 0; i < this.configData['multiAffectedColumns'].length; i++) {
            const element = this.configData['multiAffectedColumns'][i];
            element?.value.forEach(field => {
              if (field?.action == "SET_ERROR" && frmGroup?.value?.value == element?.key[0]) {
               frmGroup.setErrors({ 'onValueSelection': { 'message': field.errorMessage } });
              }
            });
          }
        }
      }
    }

  ngAfterViewInit(){
    this.toggleDisable(this.configData['disabled']);
    //Check dependent field and set values
    if(this.configData?.dynamicDependentCom && this.frmGroup?.get(this.configData.name)?.value != ''){
      this.frmGroup.get(this.configData.dynamicDependentCom).setValue(this.frmGroup?.get(this.configData.name)?.value)
    }
    //end
    if(this.configData?.UoMkey){
      let data = localStorage.getItem("preferredUOM")
      let copyOrderData = localStorage.getItem("copyOrderData")
      if (this.configData.UoMkey == data) {
          let uomOptions = []
          uomOptions = this.configData.options;
          let uom = this.frmGroup.get(this.configData.name).value;
          if (typeof uom === 'object' && uom !== null && 'value' in uom) {
            uom = uom.value;
          }
          if (this.configData.isconvertUom || copyOrderData !== null) {
              if (uomOptions.findIndex(option => option.value === uom) !== -1 && uom !== '') {
                  this.frmGroup.get(this.configData.name).setValue(uom);
              } else {
                this.frmGroup.get(this.configData.name).setValue(this.configData.defaultValue?.value)
              }
          } else {
              this.frmGroup.get(this.configData.name).setValue(this.configData.defaultValue?.value)
          }
      }
      if (this.configData?.makeDisable === true){
        this.frmGroup.get(this.configData.name).disable();
      }
  }
  
    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj?.[this.configData.name]) {
      let selectedOption = filterObj[this.configData.name];
      this.frmGroup.get(this.configData.name).setValue(selectedOption);
    }
    if (this.configData['dynamicWarningMsg']) {
      this.infoMsg = this.appService.dynamicWarningMsg(this.configData, this.frmGroup, '');
    }
      if (typeof this.fieldControl?.value === 'object') {
        let itemObj = this.listOptions.find((data) => {
          if (data['value'].toUpperCase() === this.fieldControl?.value?.value.toUpperCase()) {
            return data['value'];
          }
        })
        if (itemObj) {
          const hasValidationEvent = this.configData?.events?.some(e => e.event === "SELECTED_VALUE");
          if (hasValidationEvent) {
            setTimeout(() => this.selectedOption(itemObj, null, true), 1000);
          } else {
            this.selectedOption(itemObj, null, true);
          }
        }
        let frmGroup = this.frmGroup?.get(this.configData?.name);
        if (frmGroup['required'] === false && frmGroup?.errors?.required !== true) {
          this.configData.required = false;
        }
    }
  }

  toggleDisable(disabled){
    if (disabled === true) {
      this.frmGroup.get(this.configData.name).disable();
      this.formControl?.nativeElement?.parentElement?.classList.add('disabled');
    } else {
      this.frmGroup.get(this.configData.name).enable();
      this.formControl?.nativeElement?.parentElement?.classList.remove('disabled');
    }
  }

  toggleDropdownList(event){
    this.toggleList = !this.toggleList;
  }

  selectedOption(option, userEvent, keepAffectedColumnValues = false, eventData = ""){
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'CHANGE');
    if (event && (event['actionType'] == 'CHANGE_USER_ROLES_OPTION' || event['actionType'] == 'CHANGE_CUSTOMERS_OPTION' || event['actionType'] == 'CHANGE_USER_ROLES_OPTION_UPDATE')) {
      this.sendToSource(event, option);
      this.fieldControl.setValue(option);
      return
    }
    if (option?.queryName && option?.value && this.configData['filterType'] === 'savedSearchFilter') {
      this.showDeleteFilterButton = true;
    } else {
      this.showDeleteFilterButton = false;
    }
    let copyOrderData = localStorage.getItem("copyOrderData")
  
    this.fieldControl.setValue(option);
    if(copyOrderData || !keepAffectedColumnValues){
      this.fieldControl.markAsTouched();
      this.fieldControl.markAsDirty();
  }
  this.onCommonEventHander('SELECTED_VALUE', userEvent)
  this.manageAffectedColumn(option, keepAffectedColumnValues);
  this.multiLevelAffectedColumnsV2(option, keepAffectedColumnValues);
  this.manageMultiAffectedColumn(option, keepAffectedColumnValues);
  //Check dependent field and set values
  if(this.configData?.dynamicDependentCom){
    this.frmGroup.get(this.configData?.dynamicDependentCom).setValue(option?.value);
  }
  //end

  //send uom dropdown values to rateLookup screen.
  if(this.configData.volCalculation){
    let event: DhlFormControlEvent
    setTimeout(() => {
      this.sendVolumeDataToSource(event, this.frmGroup.value);
    })
  }
    //end
    this.cdr.detectChanges();
    this.alphaService.setAffectedColumnValues(keepAffectedColumnValues);
  }

  sendVolumeDataToSource(event: DhlFormControlEvent, row = {} ) {
    let eventData: DhlFormControlEventData = {
      action: 'VOLUME_CALCULATION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: row,
      event: 'RATE_LOOKUP',
      eventData: undefined
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  deleteSearch(userEvent) {
    let filterValue = this.frmGroup.get(this.configData.name).value.queryName
    let event = { actionType: 'DELETE_SAVED_FILTER', filterID: filterValue }
    this.sendToSource(event, userEvent);
  }
  clearFieldValue(){
    this.frmGroup.get(this.configData.name).reset();
    this.showDeleteFilterButton = false;
  }
  fieldValueValidation(validations){
    validations.forEach((validataion:string | any) => {
      let element =  (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
          this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
    }, this);
  }
  @HostListener('document:click', ['$event'])
  onWindowClick(event) {
    if (!this._eref.nativeElement.contains(event.target))
      this.toggleList = false;
  }

  positionSimpleDropdown() {
    const virtualScrollWrapper = document.getElementById('virtual-scroll-wrapper');
    const formControl = this.visibleFormControl.nativeElement;
    const dropdownList = this.visibleDropdownList.nativeElement;

    const { left: formControlLeft, top: formControlTop } = formControl.getBoundingClientRect();

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const formControlOffsetTop = formControlTop;
    const formControlOffsetLeft = formControlLeft + scrollX;
    const formControlWidth = formControl.offsetWidth; // Width of Calendar (visibleDropdownList)
    const formControlHeight = formControl.offsetHeight;
    const dropdownListHeight = dropdownList.offsetHeight; // Height of dropdown list (visibleDropdownList)

    if (window.innerHeight < formControlOffsetTop + dropdownListHeight) {
      dropdownList.classList.add('ulta');
      if (this.listOptions && this.listOptions.length <= 3) {
        dropdownList.classList.add('min-options-' + this.listOptions.length);
      }
    } else {
      dropdownList.classList.remove('ulta');
    }
    if (formControlOffsetLeft + formControlWidth > window.innerWidth) {
      dropdownList.classList.add('pulta');
    } else {
      dropdownList.classList.remove('pulta');
    }

    if (virtualScrollWrapper) {
      const virtualScrollWrapperTop = virtualScrollWrapper.getBoundingClientRect().top;
      const virtualScrollWrapperHeight = virtualScrollWrapper.clientHeight;
      const visualLimitCalc = (formControlTop - virtualScrollWrapperTop) + formControlHeight + dropdownListHeight;
      const showOnTop = visualLimitCalc > virtualScrollWrapperHeight;
      if (showOnTop) {
        const position = (dropdownListHeight * -1) + 6;
        this.visibleDropdownList.nativeElement.classList.add('ulta');
        this.visibleDropdownList.nativeElement.style.top = `${position}px`;
      } else {
        this.visibleDropdownList.nativeElement.classList.remove('ulta');
        this.visibleDropdownList.nativeElement.style.top = '';
      }
    }
  }

  toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden']) {
    this.configData.required = !hidden; // if fied is visible, it will be mandatory because we loose initial required data
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    if (hidden === true) {
      this.frmGroup.get(this.configData.name).reset();
      this.frmGroup.get(this.configData.name).setErrors(null);  // to remove required validation from form in case of hidden                  
      this.frmGroup.get(this.configData.name).clearValidators();
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
      if(this.frmGroup.get(this.configData.name).value == null || this.frmGroup.get(this.configData.name).value == undefined){
        this.frmGroup.get(this.configData.name).setValue('');
      }
    } else {
      // Set validation if field is not hidden and field is required
      if(this.configData.required){
        this.frmGroup.get(this.configData.name).setValidators([Validators.required]);
        this.frmGroup.get(this.configData.name).updateValueAndValidity();   
      }
    }

    // Set default dropdown value when field is visible again. 
    if(this.configData["setDefaultDropdownValue"]){
      if((!this.frmGroup.get(this.configData.name).value || this.frmGroup.get(this.configData.name).value === null || this.frmGroup.get(this.configData.name).value === '' || this.frmGroup.get(this.configData.name).value == undefined) && hidden === false)
        if(this.configData.defaultValue)
          this.frmGroup.get(this.configData.name).setValue(this.configData.defaultValue);
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
    }
    
    if(this.configData.events && hidden === false)
    this.onCommonEventHander('SELECTED_VALUE', null);
  }

  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      //event = (event.length ? event[0] : null);
      if (event.length === 1) {
        event = event[0];
      } else if (event.length > 1) {
        event = event;
      } else { event = null }
    }
    return event;
  }
  sendToSource(event, userEvent) {
    if(this.configData['storeDataName']){
      sessionStorage.setItem(this.configData['storeDataName'], JSON.stringify(this.fieldControl.value));
    }
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.actionType || 'MULTIPLE_ACTION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: this.frmGroup.get(this.configData.name).value
    }
    eventData['userEvent'] = userEvent;
    if(eventData['action'] == "CHANGE_USER_ROLES_OPTION" || eventData['action'] == "CHANGE_CUSTOMERS_OPTION" || eventData['action'] == "CHANGE_USER_ROLES_OPTION_UPDATE"){
      eventData['data'] = userEvent;
    }

    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj) {
      filterObj[this.configData.name] = this.frmGroup.get(this.configData.name).value;
      this.alphaService.setFilteredObject('setFiltersValues', filterObj);
    }
    
    if (event.actionType === "ENABLE_SAVE" && userEvent && this.configData["enableFilterSaveButton"]) {
      this.appService._commonComponentSubjectFilter.next(eventData);
    }
    // else if (this.configData['filterType'] === 'savedSearchFilter') {
    //   this.appService._commonComponentSubjectFilter.next(eventData);
    // }
    else if (this.configData['filterType'] === 'savedSearchFilter' && eventData.action !== "DELETE_SAVED_FILTER") {
      this.appService._commonComponentSubjectFilter.next(eventData);
    }
    else {
      this.appService._commonComponentSubject.next(eventData);
    }
  }

  checkAccess(access) {
    let menuPages = localStorage.getItem('menuPages');
    return menuPages.includes(access);
  }

  manageAffectedColumn(data, keepAffectedColumnValues = false) {
    if (this.configData['affectedColumns']) {
      this.configData['affectedColumns'].forEach(element => {
        let multipleValue;
        let multipleKey;
        if (element.multipleValue && element.multipleKey) {
          multipleValue = element.multipleValue;
          multipleKey = element.multipleKey;
        } else {
          multipleValue = element.value;
          multipleKey = element.key;
        }
        multipleValue.forEach(field => {
          let hidden = multipleKey.includes(data.value) ? false : true;
          this.frmGroup.get(field.name)['hidden'] = hidden;
          if (hidden === true) {
            this.frmGroup.get(field.name).reset();
            this.frmGroup.get(field.name).removeValidators([Validators.required]);
            this.frmGroup.get(field.name)['required'] = false;
            this.frmGroup.get(field.name).setErrors(null);
          }
          else {
            if (field.required) {
              this.frmGroup.get(field.name)['required'] = field.required;
              this.frmGroup.get(field.name).addValidators([Validators.required]);
            } else if (!field.required){
              this.frmGroup.get(field.name)['required'] = field.required;
              this.frmGroup.get(field.name).removeValidators([Validators.required]);
              this.frmGroup.get(field.name).setErrors(null);
            }
          }
          this.frmGroup.get(field.name).updateValueAndValidity();
        })
      });
    }
  }
  validateGroupvalidation(){
    this.alphaService.mapConfigDataControls(this.configData);
    this.alphaService.executeGroupValidations({
      validations: this.configData.groupValidations,
      formGroup: this.frmGroup,
      shouldValidate: true,
      shouldSubscribe: true,
    });
    this.appService.groupValidationSubscription$.subscribe(() => {
      this.alphaService.executeGroupValidations({
        validations: this.configData.groupValidations,
        formGroup: this.frmGroup,
        shouldValidate: true,
        shouldSubscribe: true,
      });
    });
  }

  private handleGskNumberVisibilitySimple(selectedValue: string) {
    const checkAndModify = (controlName: string, hidden: boolean, clearError: boolean) => {
      const controlInfo = this.alphaService.getControl(controlName, this.frmGroup);
      if (controlInfo?.control) {
        controlInfo.control.hidden = hidden;
        if (clearError) controlInfo.control.setErrors(null);
      }
    };
  
    if (selectedValue !== this.configData?.groupValidationField) {
     for(let prop in this.configData?.groupValidations[0]?.fields)
      checkAndModify(this.configData?.groupValidations[0]?.fields[prop], true, true);
    }
  }

  multiLevelAffectedColumnsV2(data: any, keepAffectedColumnValues = false) {
    if(data?.value===this.configData?.groupValidationField){
      this.validateGroupvalidation();
    }
  
    const affectedColumns = this.configData['multiLevelAffectedColumnsV2'];
    if(!affectedColumns) return;
    for (const element of affectedColumns) {
      const isMatch = this.alphaService.compareValues(element.key, data);
      let temp
      let ctrlSub
      let validationList 
      let hiddenIndex
      let fieldConfigName
      if (!isMatch) continue;
      for (const fieldConfig of element.value) {
        const controlInfo = this.alphaService.getControl(fieldConfig?.name, this.frmGroup);
        const control = controlInfo?.control;
        if(fieldConfig.dynamicSectionShow){
         temp = this.appService.getOrderTemplate()
         let fieldConfigControl = this.alphaService.getControlFromJsonTemplate(temp,fieldConfig?.name)
         validationList = fieldConfigControl?.validation || [];
         hiddenIndex = validationList?.indexOf("hidden");
        }
        if (!control) continue;
        this.appService.handleRemoveWarningMessage(fieldConfig);

        if (fieldConfig.action === "SHOW") {
          if (fieldConfig.reset && !keepAffectedColumnValues) this.alphaService.isReset(fieldConfig, controlInfo.multilevelformGroup);
          control['hidden'] = false;
          this.alphaService.isRequired(fieldConfig, controlInfo.multilevelformGroup);
          if(fieldConfig.dynamicSectionShow){
            if (hiddenIndex > -1) validationList.splice(hiddenIndex, 1);
          }
        } else if (fieldConfig.action === "HIDE") {
          if (fieldConfig.reset && !keepAffectedColumnValues) this.alphaService.isReset(fieldConfig, controlInfo.multilevelformGroup);
          control['required'] = false;
          control['hidden'] = true;
          control.removeValidators([Validators.required]);
          if(fieldConfig.dynamicSectionShow){
            if (hiddenIndex === -1) validationList.push("hidden");
          }
        } else if (fieldConfig.action === "SET_ERROR") {
          control['hidden'] = false;
          control.setErrors({ 'onValueSelection': { 'message': fieldConfig.errorMessage } });
        }
        control.updateValueAndValidity();
      }

      this.handleGskNumberVisibilitySimple(data?.value);

      if (this.configData?.apiUrl) {
        this.makeapicall(data?.value, element.value);
      }

      return; // Exit after the first matching 'element' is processed
    }
  }

  onCommonEventHander(eventType, userEvent) {
    if (this.configData.name === "docType") {
      let eventData: DhlFormControlEventData = {
        event: null,
        eventData: null,
        action: 'Dropdown_ChangeEvent',
        name: this.configData.name,
        component: null,
        configData: this.configData,
        data: this.frmGroup.get(this.configData.name).value
      }
      this.appService._commonComponentSubject.next(eventData);
    }
    if(!userEvent && !this.frmGroup.get(this.configData.name)?.value) this.manageMultiAffectedColumn(this.configData.defaultValue);
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, eventType);
    let allow = false;
    if(event){
      allow =  (event['eventOnDisable'] === true && this.configData['disabled'] === true) || event['eventOnDisable'] === undefined;
    }
    if (this.frmGroup.get(this.configData.name).valid || allow) {
      if (event) {
        this.sendToSource(event, userEvent);
        return
      }
      else if(!event && userEvent && this.configData["enableFilterSaveButton"]){
        this.sendToSource({"actionType" : "ENABLE_SAVE"}, userEvent);
      }
    }
  }

  manageMultiAffectedColumn(data, keepAffectedColumnValues = false) {
    let isMatch = false, fieldCtrl, value;
    if(this.configData['multiAffectedColumns']) {
      for (let i = 0; i < this.configData['multiAffectedColumns'].length; i++) {
        const element = this.configData['multiAffectedColumns'][i];
        let isUpdadatInputs = false;
        element.value.forEach(field => {
          isMatch = this.alphaService.compareValues(element.key, data);
          fieldCtrl = this.frmGroup?.get(field?.name);
          value = this.frmGroup?.get(field?.name)?.value;
          if (field?.warningMsg !== "" && field?.warningMsg !== undefined && isMatch) {
            let warning = {
              message: { "configDataLabel": field?.warningMsg },
            }
            this.infoMsg = { 'warning': true, message: warning?.message };
          } else if (!isMatch) {
            this.infoMsg = { 'warning': false, message: '' };
          }else{
            this.infoMsg = { 'warning': false, message: '' };
          }
          this.appService.handleRemoveWarningMessage(field);
           if(!fieldCtrl && !value){
            if (field.action === "SHOW" && field?.isSectionShow) {
              this.appService._components[field.name].frmGroup.get(field.name)['hidden'] = false;
              this.appService._components[field.name].frmGroup.get(field.name)['required'] = true;
            } if (field.action === "HIDE" && field?.isSectionShow=== false) {
              this.appService._components[field.name].frmGroup.get(field.name)['hidden'] = true;
              this.appService._components[field.name].frmGroup.get(field.name)['required'] = false;
            }
          }
          
         if (field.action === "SHOW" && isMatch && fieldCtrl) {
            if(field.reset && !keepAffectedColumnValues) this.alphaService.isReset(field, this.frmGroup);
            this.frmGroup.get(field.name)['hidden'] = false;
            this.alphaService.isRequired(field, this.frmGroup);
            if(this.appService._components[field.name]?.hide){
              this.appService._components[field.name].hide=false
            }
          } else if (field.action === "HIDE" && isMatch && fieldCtrl) {
            if(field.reset && !keepAffectedColumnValues) this.alphaService.isReset(field, this.frmGroup);
            this.frmGroup.get(field.name)['required'] = false;
            this.frmGroup.get(field.name)['hidden'] = true;
             if(this.appService._components[field.name]?.hide){
              this.appService._components[field.name].hide=true
            }
            this.frmGroup.get(field.name).removeValidators([Validators.required]);
          } else if (field.action === "DEPENDENT_FIELD" && fieldCtrl && this.alphaService.compareValues(element.key, this.frmGroup.get(field.dependentFieldName).value)) {
            if(field.reset) this.alphaService.isReset(field, this.frmGroup);
            this.alphaService.isRequired(field, this.frmGroup);
          } else if (field.action == "SETDATA" && isMatch && fieldCtrl) {
            this.frmGroup.get(field.name)["hidden"] = false;
            this.alphaService.isRequired(field, this.frmGroup);
            if (field?.defaultValue && (field?.reset || this.alphaService.isBlank(value))) this.frmGroup.get(field.name).setValue(field.defaultValue);
            isUpdadatInputs = true;
          } else if (field.action === "VOLUME_CALCULATION") {
            if(!keepAffectedColumnValues) this.alphaService.calculateVolume(field, this.frmGroup);
          } else if (field.action !== "DEPENDENT_FIELD" && field.action !== "SET_ERROR" && fieldCtrl) {
            if(!keepAffectedColumnValues) this.alphaService.isReset(field, this.frmGroup);
            this.frmGroup.get(field.name)['required'] = false;
            this.frmGroup.get(field.name)['hidden'] = true;
            this.frmGroup.get(field.name).removeValidators([Validators.required]);
          }
          this.frmGroup?.get(field?.name)?.updateValueAndValidity();
          
          //Set error selection of dropdown 
          if (field.action == "SET_ERROR" && isMatch) {
            this.frmGroup.get(field.name)['hidden'] = false;   
            this.frmGroup.get(field.name).setErrors({ 'onValueSelection': { 'message': field.errorMessage } });
          }
          //End
        });
         //THU Dimension Autocomplete api call
         if(this.configData?.apiUrl && isUpdadatInputs){
          this.makeapicall(data?.value, element.value);
        }
        //end
        if(this.alphaService.compareValues(element.key, data)) break;
      }
    }
  }

  //Mapped drop-down option dynamically
  dynamicDropDownList(options) {
    if(options?.length > 0) {
      this.listOptions.length = 0;
      this.listOptions.push(...options);
    }
  }

  makeapicall(searchText, valuesArray) {
    let url = this.configData["apiUrl"];
    url += searchText;
    url += '&userId=' + localStorage.getItem('userName');
    url += "&customerCode=" + localStorage.getItem('customerCode');
    this.appService.makeHttpGetRequest(url).subscribe(
      (response) => {
        if (response['message'].statusCode === APP_Constants.SUCCESS_CODE) {
          valuesArray.forEach(obj => {
            if (response['searchResult'] && response['searchResult'].length > 0) {
              this.frmGroup.get(obj.name).setValue(response['searchResult'][0][obj.OTMKey]);
            } else {
              this.frmGroup.get(obj.name).setValue('');
            }
          });
        }
      },
      (error) => {
        let modal = new Modal({
          action: false,
          name: "autocomplete",
          title: "Dropdown",
          description: error.message,
          actionButtonText: "",
        });
        this.modalService.createModalBox(modal, error.status);
      }
    );
  }

  setValueBySelection(option) {
    if (option != undefined) {
      this.selectedOption(option, null);
    }
  }

  setValueToControl(option) {
    if (option) {
      this.frmGroup.get(this.configData.name).setValue(option);
    }
  }
}